'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _colonyJsContractClient = require('@colony/colony-js-contract-client');

var _colonyJsContractClient2 = _interopRequireDefault(_colonyJsContractClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LookupRegisteredENSDomain = function (_ContractClient$Calle) {
  (0, _inherits3.default)(LookupRegisteredENSDomain, _ContractClient$Calle);

  function LookupRegisteredENSDomain() {
    (0, _classCallCheck3.default)(this, LookupRegisteredENSDomain);
    return (0, _possibleConstructorReturn3.default)(this, (LookupRegisteredENSDomain.__proto__ || Object.getPrototypeOf(LookupRegisteredENSDomain)).apply(this, arguments));
  }

  (0, _createClass3.default)(LookupRegisteredENSDomain, [{
    key: 'convertOutputValues',
    value: function convertOutputValues(result) {
      var _get$call = (0, _get3.default)(LookupRegisteredENSDomain.prototype.__proto__ || Object.getPrototypeOf(LookupRegisteredENSDomain.prototype), 'convertOutputValues', this).call(this, result),
          domain = _get$call.domain;

      // if we're on a known testnet, patch the returned ENS domain to use .test


      if (domain && domain.length && this.client.network === 'goerli') {
        var _domain$split = domain.split('.'),
            _domain$split2 = (0, _slicedToArray3.default)(_domain$split, 2),
            name = _domain$split2[0],
            scope = _domain$split2[1];

        var patchedDomain = name + '.' + scope + '.joincolony.test';
        return { domain: patchedDomain };
      }

      return { domain: domain };
    }
  }]);
  return LookupRegisteredENSDomain;
}(_colonyJsContractClient2.default.Caller);

exports.default = LookupRegisteredENSDomain;
//# sourceMappingURL=LookupRegisteredENSDomain.js.map